import { modules } from '@/store/modules';

const unresetableModules = ['brands', 'mdm', 'cpfSearched', 'validation', 'currentAdmission'];

const resetStatesVuexPersist = ({ commit }) => {
  Object.keys(modules).forEach((moduleName) => {
    if (!unresetableModules.includes(moduleName)) {
      moduleName === 'global'
        ? commit('global/SET_CLEAR_GLOBAL')
        : commit(`SET_CLEAR_${moduleName.toUpperCase()}`);
    }
  });
};

export default resetStatesVuexPersist;
